import Api from './Api';

class CertidaoApi extends Api {
    async recuperarRascunhoCertidao(idSessao, processo) {
        const url = `${this.configuracao.urlSessoes + idSessao}/processos/${processo}/rascunho-certidao/`;
        let result = await this.fetch(url);
        return result.data;
    }

    async criarCertidao(idSessao, processo, body, tratamentoErroComponente) {
        const url = `${this.configuracao.urlSessoes + idSessao}/processos/${processo}/certidao-julgamento/`;
        return this.fetchConfig({
            url: url,
            method: 'POST',
            data: body,
            tratamentoErroComponente: tratamentoErroComponente
        });
    }

    async atualizarResumo(idSessao, processo, body) {
        const url = `${this.configuracao.urlSessoes + idSessao}/processos/${processo}/certidao-julgamento/texto/resumo`;
        let result = await this.fetch(url, 'POST', body);
        return result.data;
    }

    async recuperarCamposCertidao(idSessao, processo, siglaOJC, nomeOJC, tipoJulgamentoSessao, tipoJulgamento) {
        const url = `${this.configuracao.urlSessoes + idSessao
            }/processos/${processo}/certidao-julgamento?siglaOjc=${siglaOJC}&nomeOjc=${nomeOJC}&tipoJulgamentoSessao=${tipoJulgamentoSessao}&tipoJulgamento=${tipoJulgamento}`;
        let result = await this.fetch(url);
        return result.data;
    }

    async salvarRascunhoCertidao(idSessao, processo, rascunho) {
        const url = `${this.configuracao.urlSessoes + idSessao}/processos/${processo}/rascunho-certidao`;
        await this.fetch(url, 'POST', rascunho, [{ parametro: 'Content-type', valor: 'text/plain' }]);
    }

    salvarRascunhoCertidaoEmLote(listaProcessos, rascunho, operacaoDecisao, operacaoObservacao) {
        const params = `?operacaoDecisao=${operacaoDecisao}&operacaoObservacao=${operacaoObservacao}`;
        const url = `${this.configuracao.urlSessoes}processos/rascunho-certidao-lote${params}`;
        return this.fetchConfig({
            url: url,
            method: 'POST',
            data: { listaProcessos, rascunho },
            tratamentoErroComponente: true
        });
    }

    async salvarResumo(idSessao, processo, resumo) {
        const url = `${this.configuracao.urlSessoes + idSessao}/processos/${processo}/certidao-julgamento/texto/resumo`;
        await this.fetch(url, 'PUT', resumo, [{ parametro: 'Content-type', valor: 'text/plain' }]);
    }

    async salvarDecisao(idSessao, processo, decisao) {
        const url = `${this.configuracao.urlSessoes + idSessao}/processos/${processo}/certidao-julgamento/texto/decisao`;
        await this.fetch(url, 'PUT', decisao, [{ parametro: 'Content-type', valor: 'text/plain' }]);
    }

    async salvarPartes(idSessao, processo, partes) {
        const url = `${this.configuracao.urlSessoes + idSessao}/processos/${processo}/certidao-julgamento/texto/partes`;
        await this.fetch(url, 'PUT', partes, [{ parametro: 'Content-type', valor: 'text/plain' }]);
    }

    async excluirResumo(idSessao, processo) {
        const url = `${this.configuracao.urlSessoes + idSessao}/processos/${processo}/certidao-julgamento/texto/resumo`;
        await this.fetch(url, 'DELETE');
    }

    async excluirDecisao(idSessao, processo) {
        const url = `${this.configuracao.urlSessoes + idSessao}/processos/${processo}/certidao-julgamento/texto/decisao`;
        await this.fetch(url, 'DELETE');
    }

    async excluirPartes(idSessao, processo) {
        const url = `${this.configuracao.urlSessoes + idSessao}/processos/${processo}/certidao-julgamento/texto/partes`;
        await this.fetch(url, 'DELETE');
    }

    async salvarCpfSignatario(idSessao, processo, cpfSignatario) {
        const url = `${this.configuracao.urlSessoes + idSessao
            }/processos/${processo}/certidao-julgamento/texto/cpf-signatario`;
        await this.fetch(url, 'PUT', cpfSignatario, [{ parametro: 'Content-type', valor: 'text/plain' }]);
    }

    async salvarRedator(idSessao, processo, redator) {
        let body = redator;
        const url = `${this.configuracao.urlSessoes + idSessao}/processos/${processo}/redator`;
        await this.fetch(url, 'POST', body, [{ parametro: 'Content-type', valor: 'application/json' }]);
    }

    async removerRedator(idSessao, processo) {
        const url = `${this.configuracao.urlSessoes + idSessao}/processos/${processo}/redator`;
        await this.fetch(url, 'DELETE');
    }

    async removerAssinaturaCertidao(idSessao, processo) {
        const url = `${this.configuracao.urlSessoes + idSessao}/processos/${processo}/certidao-julgamento/assinatura`;
        await this.fetch(url, 'DELETE');
    }

    async deleteRascunhoCertidao(idSessao, processo) {
        const url = `${this.configuracao.urlSessoes + idSessao}/processos/${processo}/rascunho-certidao`;
        await this.fetch(url, 'DELETE');
    }

    async transferirCertidao(idSessao, processos) {
        const url = `${this.configuracao.urlSessoes + idSessao}/transferir-certidoes/`;
        return this.fetch(url, 'POST', processos);
    }

    async salvarPresidente(idSessao, processo, presidente, cargoSignatario) {
        const params = cargoSignatario ? `?cargoSignatario=${encodeURIComponent(cargoSignatario)}` : '';
        const url = `${this.configuracao.urlSessoes + idSessao}/processos/${processo}/presidente${params}`;
        await this.fetch(url, 'PUT', presidente, [{ parametro: 'Content-type', valor: 'application/json' }]);
    }

    async removerPresidente(idSessao, processo) {
        const url = `${this.configuracao.urlSessoes + idSessao}/processos/${processo}/presidente`;
        await this.fetch(url, 'DELETE');
    }
}

export default CertidaoApi;
